// Regroups all declared translation files 

const translations = {
    de_DE: require('./de_DE.json'),
    en_GB: require('./en_GB.json'),
    es_ES: require('./es_ES.json'),
    fr_FR: require('./fr_FR.json'),
    it_IT: require('./it_IT.json'),
    ja_JP: require('./ja_JP.json'),
    pt_PT: require('./pt_PT.json'),
    ru_RU: require('./ru_RU.json'),
    zh_CN: require('./zh_CN.json'),
}

export default translations;


// WEBPACK FOOTER //
// ./src/translate/AllTranslations.js